<template>
  <p class="text-gray-600 text-right text-sm">
    Made by
    <a href="https://twitter.com/Jhonel_Rios" target="_blank">Jhonel Rios</a>
    with
    <a href="https://platzi.com/" target="_blank">Platzi</a>
  </p>
</template>

<script>
export default {
  name: 'MadeBy'
};
</script>

<style lang="scss" scoped>
a {
  @apply text-blue-600;
}

a:hover {
  text-decoration: underline;
}
</style>
